var m = require('mithril');
var formGroup = require('../formGroup');
var ToggleSwitch = require('../toggleSwitch');

function normalizeBoolean(value) {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    var normalized = value.trim().toLowerCase();
    return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on';
  }
  return false;
}

function getOnValue(field, currentValue) {
  if (typeof field.onValue !== 'undefined') return field.onValue;
  if (typeof field.trueValue !== 'undefined') return field.trueValue;
  if (typeof currentValue === 'number' || typeof field.default === 'number') return 1;
  if (currentValue === '0' || currentValue === '1' || field.default === '0' || field.default === '1') return 1;
  return true;
}

function getOffValue(field, currentValue) {
  if (typeof field.offValue !== 'undefined') return field.offValue;
  if (typeof field.falseValue !== 'undefined') return field.falseValue;
  if (typeof currentValue === 'number' || typeof field.default === 'number') return 0;
  if (currentValue === '0' || currentValue === '1' || field.default === '0' || field.default === '1') return 0;
  return false;
}

module.exports = {
  view: function view(vnode) {
    var field = vnode.attrs.field || {};
    var value = vnode.attrs.prop();
    var checked = normalizeBoolean(value);
    var inputId = (field.id || field.name || 'switch') + '-input';

    return m(formGroup, [
      m('div.flex.items-center.justify-between', [
        m('label', { for: inputId }, field.name),
        m(ToggleSwitch, {
          id: inputId,
          size: 'modal',
          checked: checked,
          ariaLabel: field.name,
          onchange: function () {
            vnode.attrs.prop(checked ? getOffValue(field, value) : getOnValue(field, value));
          }
        })
      ])
    ]);
  }
};
